// src/components/application/HousingSummary.tsx
import React from "react";
import { useTranslation } from "react-i18next";
import { ApplicationHousingEntry } from "../../types";

export interface HousingSummaryProps {
  entries: ApplicationHousingEntry[];
}

export const HousingSummary: React.FC<HousingSummaryProps> = ({ entries }) => {
  const { t } = useTranslation();
  if (!entries.length) return null;
  const latest =
    entries.find((e) => e.currentResidence) || entries[entries.length - 1];
  return (
    <p>
      <strong>{t("housingSummary.latestLabel")}:</strong> {latest.address}
    </p>
  );
};
